import { BarChartRounded, PeopleAltRounded, PieChartRounded } from '@mui/icons-material';
import { startCase } from 'lodash';

export enum TypeActivitiesTab {
  MY_ACTIVITIES = 'my_activities',
  TEAM_ACTIVITIES = 'team_activities',
  TEAM_MANAGEMENT = 'team_management',
}

export const LIS_ACTIVITIES_TABS = [
  {
    key: TypeActivitiesTab.MY_ACTIVITIES,
    label: startCase(TypeActivitiesTab.MY_ACTIVITIES),
    icon: PieChartRounded,
  },
  {
    key: TypeActivitiesTab.TEAM_ACTIVITIES,
    label: startCase(TypeActivitiesTab.TEAM_ACTIVITIES),
    icon: BarChartRounded,
  },
  {
    key: TypeActivitiesTab.TEAM_MANAGEMENT,
    label: startCase(TypeActivitiesTab.TEAM_MANAGEMENT),
    icon: PeopleAltRounded,
  },
];

export const UserSpendingByFeatures = ['COMPANY', 'PEOPLE', 'TRADE_DATA'];
